var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 10.61L18.06 1.12C17.68 0.7 17.09 0.54 16.56 0.73C16.02 0.92 15.65 1.4 15.62 1.97L15.4 5.7C11.65 5.63 8.07 6.96 5.28 9.45C1.51 12.8 -0.290003 17.8 0.459997 22.83C0.549997 23.46 1.06001 23.94 1.69001 24.02C1.74001 24.02 1.79 24.03 1.84 24.03C2.41 24.03 2.94 23.68 3.15 23.14C3.8 21.46 4.81 20 6.15 18.81C8.52 16.7 11.64 15.71 14.79 16.03L14.56 19.92C14.53 20.49 14.84 21.01 15.35 21.26C15.87 21.51 16.47 21.43 16.89 21.05L26.38 12.61C26.66 12.36 26.83 12.02 26.85 11.65C26.88 11.25 26.75 10.89 26.5 10.61ZM15.97 19.98L16.24 15.44C16.26 15.08 16.01 14.76 15.65 14.71C11.87 14.11 8.07002 15.21 5.23002 17.74C3.72002 19.08 2.59001 20.72 1.85001 22.61C1.17001 18.06 2.80001 13.52 6.22001 10.49C8.70001 8.29 11.85 7.1 15.18 7.1C15.46 7.1 15.74 7.11 16.02 7.13C16.21 7.15 16.39 7.08 16.53 6.95C16.67 6.82 16.75 6.65 16.76 6.47L17.02 2.06L25.46 11.55L15.97 19.98Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f4ff57ad.svg";
export { ForwardRef as ReactComponent };